import { apiPathFunc } from "@api/util/apiPathFunc";
import { exportExcel } from "src/api/stores/financial/exportExcel/path";
import { exportPDF } from "src/api/stores/financial/exportPDF/path";
import { stats } from "src/api/stores/financial/stats/path";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/financials/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const financial = {
  getAll: apiPathFunc(pathBase),
  stats,
  exportPDF,
  exportExcel,
};
